<template>
  <div class="wrapper">
    <div class="content">
      <h1 class="title">用户使用协议</h1>
      <strong style="line-height: 1.5"
        >【化工园区一体化监管平台】用户注册协议由西昌钒钛产业园区化工园区（以下简称本公司）和您签订。请您仔细阅读本协议，您点击确认后，本协议即构成对双方有约束力的法律文件。</strong
      >
      <p>
        <strong>1、 声明与承诺</strong>
      </p>
      <p class="first-title">
        1.1
        您确认，在您注册成为【化工园区一体化监管平台】用户以接受本服务前，或您以本公司允许的其他方式实际使用本服务前，您已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议之所有约定。
      </p>
      <p class="first-title">
        1.2
        您同意，本公司有权根据需要修改本协议的内容。如本服务各项规则有任何变更，本公司将在【化工园区一体化监管平台】上发布公告，不再向用户作个别通知。经修订的相关条款和规则一经公告，即于公告规定的特定生效日期自动生效。如果您不同意本公司对本协议所做的修改，您有权停止使用本公司服务。如果您继续使用本公司服务，则视为您接收本公司对本协议所做的修改，并应遵照修改后的协议执行。
      </p>
      <p class="first-title">
        1.3
        您保证，在您同意接受本协议并注册成为【化工园区一体化监管平台】用户时，您必须满足如下主体资格条件：您必须是中国大陆公民，年满18周岁以上，且具有完全的民事权利能力及民事行为能力的自然人。如您不具备前述条件，您应终止注册或停止使用本服务。
      </p>
      <p class="first-title">
        1.4
        用户点击同意本协议的，即视为用户确认自己具有享受本平台服务等相应的权利能力和行为能力，能够独立承担法律责任。
      </p>
      <p class="first-title">
        1.5
        【化工园区一体化监管平台】保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
      </p>

      <p>
        <strong>2、 【化工园区一体化监管平台】用户</strong>
      </p>
      <p class="first-title">
        2.1
        您根据本协议注册【化工园区一体化监管平台】时，您应妥善保管注册用户名及密码。在您成功注册成为【化工园区一体化监管平台】用户后，您确认，只有您本人具备并使用您的【化工园区一体化监管平台】用户资格。
      </p>
      <p class="first-title">
        2.2
        您应自行诚信向本平台提供注册资料，您同意其提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动的，应及时更新其注册资料。如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且【化工园区一体化监管平台】保留终止用户使用【化工园区一体化监管平台】各项服务的权利。
      </p>
      <p class="first-title">
        2.3
        您在本平台进行浏览等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本平台将予以严格保密。
      </p>
      <p class="first-title">
        2.4
        用户注册成功后，将产生用户名和密码等账户信息，您可以根据本平台规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本平台并向公安机关报案。
      </p>
      <p class="first-title">
        2.5
        用户同意，【化工园区一体化监管平台】拥有通过邮件、短信电话等形式，向在本平台注册用户发送验证信息以及因子监测预警等告知信息的权利。
      </p>
      <p class="first-title">
        2.6
        用户不得将在本平台注册的账户密码泄露给他人，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。
      </p>
      <p class="first-title">
        2.7
        用户同意，【化工园区一体化监管平台】有权使用用户的注册信息、用户名、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。
      </p>
      <p class="first-title">
        2.8
        在您需要终止使用本服务时，您可以向本公司提出申请，经本公司审核同意后由本公司对您的用户资格进行注销。您同意：
      </p>
      <p class="secend-title">
        2.8.1 您所申请注销的是您本人所享有的用户资格。您应当依照本公司规定的程序进行用户资格注销。
      </p>
      <p class="secend-title">
        2.8.2
        注销将导致本公司终止为您提供本服务，本协议约定的双方的权利义务终止，但依本协议其他条款另行约定不得终止的或依其性质不能终止的除外。
      </p>
      <p class="secend-title">
        2.8.3
        您申请注销的用户资格应当不存在任何由于该注销行为而导致的未了结的合同关系与其他基于该用户资格的存在而产生或维持的权利义务，及本公司认为注销该用户资格会由此产生未了结的权利义务而产生纠纷的情况。
      </p>

      <p>
        <strong>3、 【化工园区一体化监管平台】服务</strong>
      </p>
      <p class="first-title">
        3.1
        【化工园区一体化监管平台】提供的服务包括：用户账户注册及管理服务、等，具体详情以【化工园区一体化监管平台】提供的实际服务内容为准。
      </p>
      <p class="first-title">
        3.2
        用户账户注册及管理服务：如您要使用【化工园区一体化监管平台】服务，应当按照本协议的约定注册，【化工园区一体化监管平台】对您因注册提交的相关信息负有管理及保密义务。
      </p>
      <p class="first-title">
        3.3
        由于市场变化及各种以合理商业努力难以控制的因素的影响，本平台无法保证您提交的信息能保证达成交易。
      </p>

      <p>
        <strong>4、 责任限制</strong>
      </p>
      <p class="first-title">
        4.1
        基于互联网的特殊性，本公司无法保证本服务不会中断，对于包括但不限于本公司、合作网站及相关第三方的设备、系统存在缺陷，计算机发生故障、遭到病毒、黑客攻击或者发生地震、海啸等不可抗力而造成服务中断或因此给您造成的损失，本公司不承担任何责任，有关损失由您自行承担。
      </p>
      <p class="first-title">
        4.2
        与本公司合作的第三方机构向您提供的服务及相关信息由第三方机构自行负责，本公司不对此等服务承担任何责任。
      </p>
      <p class="first-title">4.3 用户理解并认可以下条款：</p>
      <p class="secend-title">
        4.3.1
        您在注册时向【化工园区一体化监管平台】提交的用户名和密码是您在【化工园区一体化监管平台】的唯一识别信息。您注册成功后，您应当妥善保管自己的用户名和密码，并对自己的用户名及密码安全性负责，不得将注册的用户名和密码答案转让、赠与或授权给第三方使用。您确认使用您的用户名和密码登陆【化工园区一体化监管平台】后在【化工园区一体化监管平台】的一切行为均代表您本人，并由您承担相应的法律后果。
      </p>
      <p class="secend-title">
        4.3.2
        协助义务：您如发现有第三人冒用或盗用您账户及密码，或其他任何未经合法授权的情形，应立即以有效方式通知【化工园区一体化监管平台】，要求【化工园区一体化监管平台】暂停相关服务，否则由此产生的一切责任由您本人承担。同时，您理解【化工园区一体化监管平台】对您的请求采取行动需要合理期限，在此之前，【化工园区一体化监管平台】对第三人使用该服务所导致的损失不承担任何责任。
      </p>
      <p class="first-title">
        4.4
        本公司用户信息是由您本人自行提供及授权获取的，本公司无法保证该信息之准确、及时和完整。且本公司不对本服务提供任何形式的保证。
      </p>

      <p>
        <strong>5、 【化工园区一体化监管平台】使用规则</strong>
      </p>
      <p class="first-title">5.1 使用规则以平台上实时公布的使用规则为准。</p>
      <p class="first-title">5.2 用户在使用平台服务时，应当严格遵守以下义务：</p>
      <p class="secend-title">
        5.2.1 必须遵循国家的相关法律法规, 不得发布含有中国法律、法规、
        规章、条例以及任何具有法律效力之规范所限制或禁止的内容，不得发布危害国家安全、色情、暴力等任何合法权利等非法内容;
      </p>
      <p class="secend-title">5.2.2 不得传输损害国家社会公共利益和涉及国家安全的信息资料；</p>
      <p class="secend-title">
        5.2.3 不得利用平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
      </p>
      <p class="secend-title">5.2.4 不得利用在平台注册的账户进行牟利性经营活动；</p>
      <p class="secend-title">
        5.2.5 不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容。
      </p>
      <p class="first-title">
        5.3
        用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费及其他费用，用户应当赔偿。【化工园区一体化监管平台】有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、追究法律责任等措施。
      </p>

      <p>
        <strong>6、 隐私权保护</strong>
      </p>
      <p class="first-title">
        6.1
        本公司重视对用户隐私的保护。因收集您的信息是出于遵守国家法律法规的规定以及向您提供服务及提升服务质量的目的，本公司对您的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租您的任何信息。
      </p>
      <p class="first-title">6.2 您同意并授权本公司在下列情况下可将您的信息与第三方共享：</p>
      <p class="secend-title">6.2.1 获得您的同意或授权。</p>
      <p class="secend-title">
        6.2.2
        某些情况下，只有共享您的信息，才能提供您需要的服务和（或）产品，或处理您与他人的交易纠纷或争议。
      </p>
      <p class="secend-title">
        6.2.3
        某些服务和（或）产品由本公司的合作伙伴提供或由本公司与合作伙伴共同提供，本公司会与其共享提供服务和（或）产品需要的信息。
      </p>
      <p class="secend-title">6.2.4 根据法律法规的规定及有权机关的要求。</p>
      <p class="secend-title">
        6.2.5 为维护本公司和其他【化工园区一体化监管平台】用户的合法权益。
      </p>

      <p>
        <strong>7、 其他</strong>
      </p>
      <p class="first-title">
        7.1
        本协议的订立、执行、解释及争议解决均适用中华人民共和国法律（不包括香港、澳门、台湾地区）。本协议条款具有可分性，部分无效不影响其它部分效力。本公司对本协议拥有最终的解释权。
      </p>
      <p class="first-title">
        7.2 如有任何争议，应先友好协商解决，协商不成，应提交本公司所在地有管辖权的法院诉讼解决。
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 0 16px;
  overflow: hidden;
  background-color: #f4f4f4;

  .content {
    max-width: 1200px;
    margin: 0 auto;
  }

  .title {
    text-align: center;
    line-height: 1.5;
  }

  .first-title {
    font-size: 16px;
    text-indent: 16px;
    line-height: 1.5;
  }

  .secend-title {
    font-size: 16px;
    text-indent: 32px;
    line-height: 1.5;
  }
}
</style>
